import { MigrationDefinition } from './migration.types';

/**
 * Migration: V0 → V1
 *
 * Upgrade:
 * - header.geologie → extendedHeader.geologie
 * - header.morphologie → extendedHeader.morphologie
 * - extendedHeader.bodenform → header.bodenform
 * - extendedHeader.humusForm → header.humusform
 * - extendedHeader.wasserstufe → header.wasserstufe
 * - bemerkungen → header.bemerkungen
 *
 * Downgrade:
 * - Umgekehrte Verschiebungen
 */
export const migrationV0ToV1: MigrationDefinition = {
  fromVersion: 0,
  toVersion: 1,

  upgrade(doc: any): any {
    if (doc.extendedHeader) {
      // Von header nach extendedHeader (nur wenn Daten vorhanden)
      if (doc.header.geologie !== undefined) {
        doc.extendedHeader.geologie = doc.header.geologie;
        delete doc.header.geologie;
      }

      if (doc.header.morphologie !== undefined) {
        doc.extendedHeader.morphologie = doc.header.morphologie;
        delete doc.header.morphologie;
      }

      // Von extendedHeader nach header (nur wenn Daten vorhanden)
      if (doc.extendedHeader.bodenform !== undefined) {
        doc.header.bodenform = doc.extendedHeader.bodenform;
        delete doc.extendedHeader.bodenform;
      }

      if (doc.extendedHeader.humusForm !== undefined) {
        doc.header.humusform = doc.extendedHeader.humusForm;
        delete doc.extendedHeader.humusForm;
      }

      if (doc.extendedHeader.wasserstufe !== undefined) {
        doc.header.wasserstufe = doc.extendedHeader.wasserstufe;
        delete doc.extendedHeader.wasserstufe;
      }
    }

    if (doc.bemerkungen !== undefined) {
      doc.header.bemerkungen = doc.bemerkungen;
      delete doc.bemerkungen;
    }

    doc.version = 1;
    return doc;
  },

  downgrade(doc: any): any {
    if (doc.extendedHeader) {
      // Von extendedHeader zurück nach header (nur wenn Daten vorhanden)
      if (doc.extendedHeader.geologie !== undefined) {
        doc.header.geologie = doc.extendedHeader.geologie;
        delete doc.extendedHeader.geologie;
      }

      if (doc.extendedHeader.morphologie !== undefined) {
        doc.header.morphologie = doc.extendedHeader.morphologie;
        delete doc.extendedHeader.morphologie;
      }

      // Von header zurück nach extendedHeader (nur wenn Daten vorhanden)
      if (doc.header.bodenform !== undefined) {
        doc.extendedHeader.bodenform = doc.header.bodenform;
        delete doc.header.bodenform;
      }

      if (doc.header.humusform !== undefined) {
        doc.extendedHeader.humusForm = doc.header.humusform;
        delete doc.header.humusform;
      }

      if (doc.header.wasserstufe !== undefined) {
        doc.extendedHeader.wasserstufe = doc.header.wasserstufe;
        delete doc.header.wasserstufe;
      }
    }

    if (doc.header?.bemerkungen !== undefined) {
      doc.bemerkungen = doc.header.bemerkungen;
      delete doc.header.bemerkungen;
    }

    doc.version = 0;
    return doc;
  },

  dataLossWarnings: []
};
